<template>
  <div class="panel-main b1" :style="style">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      default: null
    }
  },
  data() {
    return {
    };
  },
  computed:{
    style(){
      let style = {}
      if(this.width){
        style.width = Number(this.width) ? `${this.width}px` : this.width
      }
      return style
    }
  },
  mounted(){
    
  },
  methods:{
  }
};
</script>
<style lang="less" scoped>
.panel-main{
  margin: @layout-gap;
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  overflow: auto;
}
</style>
